<template>
    <form-group :validator="v" :label="label" :label-for="id" :description="tip">
        <template slot-scope="{ attrs, listeners }">
            <b-form-select :id="id" :value="value" 
                :state="v.$dirty ? !v.$error : null"
                v-bind="attrs"
                :data-test="slug"
                v-on="listeners"
                :required="required ? true : false"
                @input="updateValue" @change="updateValue">
                <template v-slot:first>
                    <option :value="null" disabled>-- Please select an option --</option>
                </template>
                <option v-for="f in requestTypeOptions" :value="f" :key="f.code">{{f.description}}</option>
            </b-form-select>
        </template>
    </form-group>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import axiosRetry from 'axios-retry'

axiosRetry(axios, { retries: 3,
                    retryDelay: axiosRetry.exponentialDelay  })

export default {
    data: () => ({
        requestTypeOptions: []
    }),

    async mounted() {
        await this.loadRequestTypes() 
        if (this.value) {
            this.updateValue(this.requestTypeOptions.find(i=>i.code == this.value.code))
        }
    },
    props: {
        value: Object,
        label: [String],
        tip: [String],
        slug: [String],
        v: [Object],
        required: [Boolean],
    },
    computed: {
        id() {
            return _.uniqueId('positionSelector')
        },
    },
    methods: {
        updateValue(value) {
            if (value) {
                this.$emit('input', value)
            }
        },
        async loadRequestTypes() {   
          await axios.get(`${process.env.VUE_APP_API_BASE_URL}/requesttype`)
            .then(response => {
                this.requestTypeOptions = response.data.filter(function( obj ) {
                    return obj.code !== '13';
                });
            })
        }
    }
}
</script>